const OktaLoginInstructions = () => {
  return (
    <div className="flex px-4 py-4 will-change-scroll transform-gpu">
      <main className="pb-8">
        <section>
          <div className="w-full px-4">
            <h2 className={styles.mainTitle}>Switch to Okta</h2>

            <p className={styles.paragraphMb4}>Hello from Fixt and Assurant!</p>

            <p className={styles.paragraphMb8}>
              We have incorporated a new login method to our Tech App to offer better future security and login options.
              This switch took place on <strong>January 19, 2023</strong>.
            </p>

            <h2 className={styles.sectionTitle}>Step 1: Activate Okta Account</h2>

            <p className={styles.paragraphMb4}>
              You will receive an email from Okta indicating that a new account was created by Assurant for you, similar
              to this:
            </p>

            <p className={styles.imageContainer}>
              <img
                src="/okta-instructions/activation-email.png"
                alt="Okta activation email example"
                className={styles.image}
                loading="lazy"
                decoding="async"
              />
            </p>

            <p className={styles.noteParagraph}>
              <strong>Note:</strong> the activation link expires in 7 days, so be sure to follow the steps as soon as
              possible. If you are unable to set up Okta within the 7 days and the link expires, please email us at{' '}
              <a href="mailto:fixt.support@assurant.com" className={styles.link} style={{color: '#2563eb'}}>
                fixt.support@assurant.com
              </a>{' '}
              with details on your issue.
            </p>

            <p className={styles.paragraphMb4}>Click the link to &ldquo;Activate Okta Account&rdquo;.</p>

            <p className={styles.noteParagraph}>
              <strong>Note:</strong> your username will be listed below the Activate button. This will also be referred
              to as your &ldquo;Assurant LAN ID&rdquo; in other places, so be sure to keep it handy.
            </p>

            <p className={styles.paragraphMb4}>
              Enter your new password twice in the fields shown and configure a security question, then click
              &ldquo;Create My Account&rdquo;.
            </p>

            <p className={styles.imageContainerLarge}>
              <img
                src="/okta-instructions/account-creation.png"
                alt="Okta account creation form"
                className={styles.image}
                loading="lazy"
                decoding="async"
              />
            </p>

            <h2 className={styles.sectionTitle}>Step 2: Install Tech App</h2>

            <p className={styles.paragraphMb4}>
              From your mobile device, visit{' '}
              <a href="/techapp" className={styles.link} style={{color: '#2563eb'}}>
                {window.location.origin}/techapp
              </a>{' '}
              to download the most recent version. Follow the instructions to get it installed.
            </p>

            <p className={styles.noteParagraph}>
              <strong>Note:</strong> Delete the current version of Tech App (If you have it on your mobile device)
            </p>

            <p className={styles.imageContainerLarge}>
              <div className={styles.multipleImagesContainer}>
                <img
                  src="/okta-instructions/techapp-download-page.jpg"
                  alt="Tech App homepage on iOS"
                  className={styles.deviceScreenshotImage}
                  loading="lazy"
                  decoding="async"
                />
                <img
                  src="/okta-instructions/techapp-download-ios.jpg"
                  alt="Tech App homepage on iOS"
                  className={styles.deviceScreenshotImage}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </p>

            <h2 className={styles.sectionTitle}>Step 3: Login with Okta</h2>

            <p className={styles.paragraphMb4}>Open the app and tap on the &ldquo;Login&rdquo; button.</p>

            <p className={styles.imageContainer}>
              <img
                src="/okta-instructions/techapp-login-screen.jpg"
                alt="Tech App login screen"
                className={styles.deviceScreenshotImage}
                loading="lazy"
                decoding="async"
              />
            </p>

            <p className={styles.paragraphMb4}>
              Enter your Assurant LAN ID, which is your email address/username used to setup your Okta account. This was
              provided to you in the initial setup email as well. Click Next to follow the login process.
            </p>

            <img
              src="/okta-instructions/techapp-okta-login-screen.jpg"
              alt="Tech App Okta login screen"
              className={styles.deviceScreenshotImage}
              loading="lazy"
              decoding="async"
            />
          </div>
        </section>
      </main>
    </div>
  );
};

const styles = {
  mainTitle: 'text-3xl font-bold mb-6 text-gray-800 pt-6',
  sectionTitle: 'text-2xl font-bold mb-4 text-gray-800',
  paragraph: 'text-gray-700',
  paragraphMb4: 'mb-4 text-gray-700',
  paragraphMb8: 'mb-8 text-gray-700 leading-relaxed',
  noteText: 'text-md italic text-gray-600',
  noteParagraph: 'mb-4 text-md italic text-gray-600',
  image: 'max-w-full h-auto rounded-lg border shadow-sm transform-gpu',
  deviceScreenshotImage: 'w-56 max-w-full rounded border shadow-sm transform-gpu',
  imageContainer: 'mb-4',
  imageContainerLarge: 'mb-8',
  multipleImagesContainer: 'flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0',
  link: 'font-bold underline',
};

export default OktaLoginInstructions;
